module.exports = __webpack_public_path__ + "static/media/complexPic6.89c27fb4.png";